import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import SearchBar from "material-ui-search-bar";


function descendingComparator(a, b, orderBy) {
    if (a[orderBy] === null) {
        return -1;
    }
    else if (b[orderBy] === null) {
        return 1;
    }
    else if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    else if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}
function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}
const headCells = [
    { id: 'changeDate', numeric: true, disablePadding: false, label: 'Date' },
    { id: 'rangeId', numeric: false, disablePadding: true, label: 'Range ID' },
    { id: 'action', numeric: true, disablePadding: false, label: 'Action' },
    { id: 'changedByName', numeric: true, disablePadding: false, label: 'Changed By' }
];
function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort, handleSearch, handleCancelSearch, searched } = props;

    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell />
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align='center'
                        paddingBottom='50px'
                        style={{ fontSize: '1vw', padding: '5px' }}
                        sortDirection={orderBy === headCell.id ? order : false}
                        width={'15%'}
                    >
                        <div class="input-group" style={{ justifyContent: 'center' }}>
                            {headCell.id === "rangeID" &&
                                <SearchBar
                                    value={searched}
                                    onChange={(searchVal) => handleSearch(searchVal, "rangeID")}
                                    onCancelSearch={() => handleCancelSearch()}
                                    className={classes.searchbar}
                                    style={{ width: '80%' }}
                                />
                            }

                            {headCell.id != "action" &&
                                <TableSortLabel
                                    active={orderBy === headCell.id}
                                    direction={orderBy === headCell.id ? order : 'asc'}
                                    onClick={createSortHandler(headCell.id)}
                                >
                                    {(headCell.id == "changedByName" || headCell.id == "rangeId" || headCell.id == "changeDate") &&
                                        <div align='center' style={{ fontSize: '.9vw' }} >
                                            {headCell.label}
                                        </div>
                                    }
                                    {orderBy === headCell.id ? (
                                        <span className={classes.visuallyHidden}>
                                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                        </span>
                                    ) : null}
                                </TableSortLabel>
                        
                            }
                        </div>

                        {headCell.id === "action" &&
                            <select class="form-control" type="text" name="action"
                                style={{ width: '125px', fontSize: '.75vw', margin: 'auto', marginBottom: '12px' }}
                                onChange={(v) => handleSearch(v.target.value.toString(), "action")}>
                                <option value="" > Action </option>
                                <option value="Insert">Insert</option>
                                <option value="Update">Update</option>
                                <option value="Delete">Delete</option>
                            </select>
                        }
                    
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1)
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85)
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark
            },
    title: {
        flex: '1 1 100%',
        margin : 40
    }
}));

const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles();
    const { numSelected } = props;
    return (
        <Toolbar
            className={clsx(classes.root, {
                [classes.highlight]: numSelected > 0
            })}
        >
            <Typography className={classes.title} variant="h5" id="tableTitle" component="div">
                Range Audit
            </Typography>
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    },
    searchbar: {
        width: '200px',
        height: '40px'
    },
    firstCell: {
        width: '10%',
        minWidth: '20px'
    },
    bigCell: {
        width: '10px',
        heigth: '50px',
        minWidth: '20px',
        maxWidth: '10px',
        align: 'center',
        position: 'absolute',
        wordWrap: 'break-word'
    },
    subTable: {
        "& td": {
            width: '33%',
            borderLeft: '1px solid rgba(224, 224, 224, 1)'
        }
    }
}));

const getDateFormat = (date) => {
    if (date == null) return
    var newDate = date.split('T')[0];
    var dateArray = newDate.split('-');
    var year = dateArray[0].substring(2);
    var month = dateArray[1];
    var day = dateArray[2];
    var fullTime = date.split('T')[1].split('.')[0];
    var hour = fullTime.substring(0, 2);
    var finalTime;
    if (parseInt(hour) > 12) {
        if (parseInt(hour) > 21) {
            finalTime = (hour - 12) + fullTime.substring(2, 5);
        } else {
            finalTime = "0" + (hour - 12) + fullTime.substring(2, 5);
        }
        finalTime += " PM"
    } else {
        finalTime = hour + fullTime.substring(2, 5);
        finalTime += " AM"
    }
    var myDate = `${month}/${day}/${year} - ${finalTime}`
    return myDate;
}

//Format date for drop down
const getDateFormatDropDown = (date) => {
    if (date == null) return
    var newDate = date.split('T')[0];
    var dateArray = newDate.split('-');
    var year = dateArray[0];
    var month = dateArray[1];
    var day = dateArray[2];
    var myDate = `${month}/${day}/${year}`
    return myDate;
}

function CollapsedRows(props) {
    const { row, index, classes } = props;
    const [open, setOpen] = React.useState(false);

    return (
        <React.Fragment>
            <TableRow style={{ backgroundColor: index % 2 ? "#f8f8f8" : "white", height: '80px' }}>
                <TableCell class="firstCell" >
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell style={{ borderBottom: 'none', width: '25%' }}  align="center">{getDateFormat(row.changeDate)}</TableCell>
                <TableCell style={{ borderBottom: 'none', width: '20%' }}  align="center">{row.rangeId}</TableCell>
                <TableCell style={{ borderBottom: 'none', width: '25%' }}  align="center">{row.action}</TableCell>
                <TableCell style={{ borderBottom: 'none', width: '20%' }} align="center">{row.changedByName == null ? row.changedBy : row.changedByName}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={5}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Typography variant="h6" gutterBottom component="div">
                                Change Made
                            </Typography>
                            <Table size="small" aria-label="purchases" className={classes.subTable}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Details</TableCell>
                                        <TableCell>Before</TableCell>
                                        <TableCell>After</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody className={classes.subTable}>
                                    <TableRow style={{ background: '#F8F8F8' }}>
                                        <TableCell style={{ borderLeft: 'none' }}>Pool</TableCell>
                                        <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{(row.action !== 'Insert') && row.poolName}</TableCell>
                                        <TableCell
                                            style={{
                                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                            }}>
                                            {(row.action !== 'Delete') && row.poolName}
                                        </TableCell>
                                    </TableRow> 

                                    <TableRow>
                                        <TableCell style={{ borderLeft: 'none' }}>Start Number</TableCell>
                                        <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{row.startNumber}</TableCell>
                                        <TableCell
                                            style={{
                                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: row.action !== 'Delete' &&  row.startNumber != row.newStartNumber ? 'bold' : 'normal'
                                            }}>
                                            {row.newStartNumber}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow style={{ background: '#F8F8F8' }}>
                                        <TableCell style={{ borderLeft: 'none' }}>End Number</TableCell>
                                        <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{row.endNumber}</TableCell>
                                        <TableCell
                                            style={{
                                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: row.action !== 'Delete' && row.endNumber != row.newEndNumber ? 'bold' : 'normal'
                                            }}>
                                            {row.newEndNumber}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell style={{ borderLeft: 'none' }}>Total Count</TableCell>
                                        <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{row.totalCount}</TableCell>
                                        <TableCell
                                            style={{
                                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: row.action !== 'Delete' &&  row.totalCount != row.newTotalCount ? 'bold' : 'normal'
                                            }}>
                                            {row.newTotalCount}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow style={{ background: '#F8F8F8' }}>
                                        <TableCell style={{ borderLeft: 'none' }}>Carrier</TableCell>
                                        <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{row.carrierName}</TableCell>
                                        <TableCell
                                            style={{
                                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: row.action !== 'Delete' && row.carrierName != row.newCarrierName ? 'bold' : 'normal'
                                            }}>
                                            {row.newCarrierName}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell style={{ borderLeft: 'none' }}>Carrier Circuit Id</TableCell>
                                        <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{row.carrierCircuitId}</TableCell>
                                        <TableCell
                                            style={{
                                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: row.action !== 'Delete' && row.carrierCircuitId != row.newCarrierCircuitId ? 'bold' : 'normal'

                                            }}>
                                            {row.newCarrierCircuitId}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow style={{ background: '#F8F8F8' }}>
                                        <TableCell style={{ borderLeft: 'none' }}>Carrier Protocol</TableCell>
                                        <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{row.carrierProtocol}</TableCell>
                                        <TableCell
                                            style={{
                                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: row.action !== 'Delete' && row.carrierProtocol != row.newCarrierProtocol ? 'bold' : 'normal'
                                            }}>
                                            {row.newCarrierProtocol}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow style={{ borderLeft: 'none' }}>
                                        <TableCell style={{ borderLeft: 'none' }}>Call Manager FQDN</TableCell>
                                        <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{row.callManagerFqdn}</TableCell>
                                        <TableCell
                                            style={{
                                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: row.action !== 'Delete' && row.callManagerFqdn != row.newCallManagerFqdn ? 'bold' : 'normal'
                                            }}>
                                            {row.newCallManagerFqdn}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow style={{ background: '#F8F8F8' }}>
                                        <TableCell style={{ borderLeft: 'none' }}>Onboarding Engineer</TableCell>
                                        <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{row.onboardingEngineer}</TableCell>
                                        <TableCell
                                            style={{
                                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: row.action !== 'Delete' && row.onboardingEngineer != row.newOnboardingEngineer ? 'bold' : 'normal'
                                            }}>
                                            {row.newOnboardingEngineer}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell style={{ borderLeft: 'none' }}>Service Manager</TableCell>
                                        <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{row.serviceManager}</TableCell>
                                        <TableCell
                                            style={{
                                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: row.action !== 'Delete' && row.serviceManager != row.newServiceManager ? 'bold' : 'normal'
                                            }}>
                                            {row.newServiceManager}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow style={{ background: '#F8F8F8' }}>
                                        <TableCell style={{ borderLeft: 'none' }}>Session Manager</TableCell>
                                        <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{row.smeTcLocation}</TableCell>
                                        <TableCell
                                            style={{
                                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: row.action !== 'Delete' && row.smeTcLocation != row.newSmeTcLocation ? 'bold' : 'normal'
                                            }}>
                                            {row.newSmeTcLocation}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell style={{ borderLeft: 'none' }}>Onboard Date</TableCell>
                                        <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{getDateFormatDropDown(row.onboardDate)}</TableCell>
                                        <TableCell
                                            style={{
                                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: row.action !== 'Delete' && getDateFormatDropDown(row.onboardDate) != getDateFormatDropDown(row.newOnboardDate) ? 'bold' : 'normal'
                                            }}>
                                            {getDateFormatDropDown(row.newOnboardDate)}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow style={{ background: '#F8F8F8' }}>
                                        <TableCell style={{ borderLeft: 'none' }}>Offboard Date</TableCell>
                                        <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{getDateFormatDropDown(row.offboardDate)}</TableCell>
                                        <TableCell
                                            style={{
                                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: row.action !== 'Delete' && getDateFormatDropDown(row.offboardDate) != getDateFormatDropDown(row.newOffboardDate) ? 'bold' : 'normal'
                                            }}>
                                            {getDateFormatDropDown(row.newOffboardDate)}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell style={{ borderLeft: 'none' }}>Onboarding Status</TableCell>
                                        <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{row.onboardingStatus}</TableCell>
                                        <TableCell
                                            style={{
                                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: row.action !== 'Delete' && row.onboardingStatus != row.newOnboardingStatus ? 'bold' : 'normal'
                                            }}>
                                            {row.newOnboardingStatus}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}
const RangeAuditTable = ({ data: rangeAudits }) => {
    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [rows, setRows] = useState(rangeAudits);
    const [searched, setSearched] = useState("");


    const requestSearch = (searchedVal, domain) => {
        setPage(0);
        const filteredRows = rangeAudits.filter((row) => {
            if (domain === "name") {
                return row.name.toString().toLowerCase().includes(searchedVal.toLowerCase());
            }
            if (domain === "description") {
                return row.description.toString().toLowerCase().includes(searchedVal.toString().toLowerCase());
            }
            if (domain === "rangeID" && row.rangeId != null) {
                return row.rangeId.toString().toLowerCase().includes(searchedVal.toLowerCase());
            }
            if (domain === "action" && row.action != null) {
                return row.action.toString().toLowerCase().includes(searchedVal.toLowerCase());
            }

        });
        return setRows(filteredRows);
    };

    const cancelSearch = () => {
        setSearched("");
        requestSearch(searched, "action"); // Domain set to anything will work here, without cancel will break as none of the request search options will be hit! 
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <EnhancedTableToolbar />
                <TableContainer>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size={'medium'}
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            classes={classes}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.length}
                            handleSearch={requestSearch}
                            handleCancelSearch={cancelSearch}
                            searched={searched}

                        />
                        <TableBody>
                            {stableSort(rows, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    return (
                                        <CollapsedRows
                                            row={row}
                                            index={index}
                                            classes={classes}
                                        />
                                    );
                                })}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: 80 * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangeRowsPerPage={handleChangeRowsPerPage} // Material v < 4
                    onRowsPerPageChange={handleChangeRowsPerPage} // Material v > 4 
                    onPageChange={handleChangePage} // Material v > 4
                    onChangePage={handleChangePage} // Material v < 4 
                />
            </Paper>
        </div>
    );
}
export default RangeAuditTable;